module.exports = __webpack_public_path__ + "img/monyback-icon.7fe12c53.svg";